module.exports = [
  'American Association of Marriage and Family Therapists (AAMFT)',
  'American Counseling Association (ACA)',
  'American Mental Health Counselors Association (AMHCA)',
  'American Psychiatric Association (APA)',
  'American Psychiatric Nurses Association (APNA)',
  'American Psychological Association (APA)',
  'Association for Addiction Professionals (NAADAC)',
  'National Association of Psychiatric Mental Health Nurse Practitioners (NAPMHNP)',
  'National Association of Social Workers (NASW)',
];
